import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";

interface MobileBookingBarProps {
  providerName: string;
  serviceCount: number;
  onBookNowClick: (activeTab?: string) => void;
  brandColor?: string | null;
}

const MobileBookingBar = ({ providerName, serviceCount, onBookNowClick, brandColor }: MobileBookingBarProps) => {
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background border-t border-border p-4 z-50 shadow-lg">
      <div className="flex items-center justify-between gap-4">
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-foreground text-sm truncate">{providerName}</h3>
          <p className="text-muted-foreground text-xs">{serviceCount} services available</p>
        </div>
        <Button 
          className="rounded-full px-6 font-semibold flex-shrink-0"
          onClick={() => onBookNowClick()}
          style={brandColor ? { backgroundColor: brandColor } : undefined}
        >
          Book now
        </Button>
      </div>
    </div>
  );
};

export default MobileBookingBar;
